import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIdleTimer } from 'react-idle-timer';
import Router from 'next/router';
import { connect } from 'react-redux';

import delegate from '../events/delegateEvent';
import { tokenLogin, tokenAutoLogout } from '../../redux/actions/token';

const AutoLogoutService = ({
  children = null,
  loggedIn,
  autoLogout,
  updateLogin,
  updateAutoLogout,
  lang
}) => {
  useEffect(() => {
    if (window.location.search.indexOf('autoLogout=true') !== -1) {
      window.localStorage.setItem('TOKEN_AUTOLOGOUT', 'true');
    }
    if (window.location.search.indexOf('autoLogout=false') !== -1) {
      window.localStorage.setItem('TOKEN_AUTOLOGOUT', 'false');
    }
    if (window.localStorage.getItem('TOKEN_AUTOLOGOUT')) {
      updateAutoLogout(window.localStorage.getItem('TOKEN_AUTOLOGOUT') === 'true');
    }
  }, []);

  useEffect(() => {
    if (autoLogout) {
      delegate('click', 'a[target="_blank"], a[href^="tel:"], a[href^="mailto:"]', document, e => {
        e.preventDefault();
        e.target.classList.add('disabled');
      });
    }
  }, [autoLogout]);

  const handleLogout = () => {
    if (loggedIn) {
      updateLogin(false, '');
      Router.push(`/${lang}/ausstellung`).then(() => window.scrollTo(0, 0));
    }
  };

  useIdleTimer({
    element: typeof window !== 'undefined' ? document : undefined,
    onIdle: handleLogout,
    debounce: 250,
    timeout: 1000 * 180,
    disabled: !autoLogout // replaces the conditional render
  });

  return <>{children}</>;
};

AutoLogoutService.propTypes = {
  children: PropTypes.node,
  loggedIn: PropTypes.bool.isRequired,
  autoLogout: PropTypes.bool.isRequired,
  updateLogin: PropTypes.func.isRequired,
  updateAutoLogout: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch => ({
  updateLogin: (loggedIn, tokenId) => {
    dispatch(tokenLogin(loggedIn, tokenId));
  },
  updateAutoLogout: bool => {
    dispatch(tokenAutoLogout(bool));
  }
});

const mapStateToProps = ({ token, app }) => ({
  loggedIn: token.loggedIn,
  autoLogout: token.autoLogout,
  lang: app.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoLogoutService);
